<template>
  <div class="stat-pie-chart">
    <div class="chart-head">
      <div class="chart-title">{{ title }}</div>
      <slot name="controls" />
    </div>
    <VChart
      v-if="rows.length"
      class="chart"
      :option="option"
      :style="{ height: height + 'px' }"
      autoresize
    />
    <div v-else class="chart-empty" :style="{ height: height + 'px' }">{{ emptyText }}</div>
  </div>
</template>

<script>
import { computed } from 'vue';
import VChart from '@/components/charts/echarts';

const PALETTE = [
  '#007bff',
  '#12b76a',
  '#f79009',
  '#f04438',
  '#9e77ed',
  '#0ba5ec',
  '#e04f1f',
  '#66c2a5',
  '#f6c445',
  '#8d98ae',
  '#d6708e',
  '#475467',
];

export default {
  name: 'StatPieChart',
  components: { VChart },
  props: {
    title: { type: String, default: '' },
    // rows: [{ label, value }]
    rows: { type: Array, default: () => [] },
    height: { type: Number, default: 380 },
    emptyText: { type: String, default: 'Нет данных' },
    valueFormatter: { type: Function, default: (v) => v },
    // Ширина подписей вертикальной легенды справа (px).
    legendWidth: { type: Number, default: 190 },
  },
  setup(props) {
    const option = computed(() => ({
      color: PALETTE,
      tooltip: {
        trigger: 'item',
        confine: true,
        formatter: (item) =>
          `${item.marker} <b>${item.name}</b><br/>${props.valueFormatter(item.value)} (${item.percent}%)`,
      },
      // Расшифровка (легенда) — вертикально справа от графика,
      // широкие подписи усекаются (полный текст — в тултипе легенды).
      legend: {
        orient: 'vertical',
        right: 0,
        top: 'middle',
        type: 'scroll',
        textStyle: { fontSize: 11, color: '#667085', width: props.legendWidth, overflow: 'truncate' },
        tooltip: { show: true },
      },
      series: [
        {
          type: 'pie',
          radius: '58%',
          center: [props.legendWidth > 190 ? '28%' : '32%', '50%'],
          avoidLabelOverlap: true,
          itemStyle: { borderColor: '#fff', borderWidth: 2, borderRadius: 4 },
          label: { show: false },
          emphasis: { label: { show: false } },
          data: props.rows.map((row) => ({
            name: row.label,
            value: row.value,
            ...(row.color ? { itemStyle: { color: row.color } } : {}),
          })),
        },
      ],
    }));

    return { option };
  },
};
</script>

<style scoped>
.stat-pie-chart {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
}

.chart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.chart-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.chart {
  width: 100%;
}

.chart-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  font-size: 14px;
}
</style>
